import { useQuery } from "@tanstack/react-query";

import { USER_API_ROUTES } from "@/config/apiConfig";
import userAxios from "@/service/axios/userAxios";

// 인스타그램 리스트 조회
export const useGetInstagramList = (page: number, limit: number) => {
    return useQuery({
        queryKey: ["instagramList"],
        queryFn: async () => {
            const res = await userAxios.get(`${USER_API_ROUTES.INSTAGRAM_LIST}?page=${page}&limit=${limit}`);
            return res.data;
        },
    });
};
